import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next';

import leadActionsImp from '../../Actions/leadActions'
import commonActionsImp from '../../Actions/commonActions'

import routes from '../../Constants/routes'

import LeadForm from '../../Components/Leads/LeadForm'
import { useNavigate, useParams } from 'react-router-dom';
import { DefaultCard } from "../../Components/Card/Card";

function LeadEditContainer({ }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const commonActions = bindActionCreators(commonActionsImp, dispatch);
    const leadActions = bindActionCreators(leadActionsImp, dispatch);
    const form = useSelector( state => state.CommonReducer.forms && state.CommonReducer.forms.leadEdit);

    const {leadId} = useParams()
    const navigate = useNavigate();

    useEffect(() => {
        leadActions.getLead(leadId, false, true, "leadEdit");
    }, [])

    const onFieldChange = (field, value) => {
        commonActions.changeMultiFormField("leadEdit", field, value);
    }

    const onSaveClick = () => {
        leadActions.save(form, navigateToDetails);
    }

    const onCancelClick = () => {
        commonActions.cancelFormEditing("leadEdit", navigateToDetails);
    }

    const navigateToDetails = () => {
        navigate(routes.leadDetails(leadId))
    }

    if (!form) {
        return null;
    }

    return (
        <div>
            <div className="col-xs-8">
                <DefaultCard title={t('leadeditcontainer.editlead')}>
                    <LeadForm lead={form.data} onFieldChange={onFieldChange} onCancelClick={onCancelClick}
                              onSaveClick={onSaveClick}/>
                </DefaultCard>
            </div>
        </div>
    );
}

export default LeadEditContainer;